import { createEvent } from 'effector';
import { type PayinTicket } from '~/entities/payin';
import { openTicketModal } from './lib';

export const openTicket = createEvent<PayinTicket>();
openTicket.watch(openTicketModal);
